module.exports = __webpack_public_path__ + "img/kopsurat_bangun_husada.e10bcd6f.png";